import React from 'react';
import { Link } from 'react-router-dom';

export type SbPageHeaderProps = {
  title: string;
  subtitle?: string;
  backTo?: { to: string; label: string };
  /** Right-side actions (e.g. primary CTA). */
  actions?: React.ReactNode;
  breadcrumb?: { to: string; label: string }[];
};

export default function SbPageHeader({
  title,
  subtitle,
  backTo,
  actions,
  breadcrumb,
}: SbPageHeaderProps) {
  return (
    <header className="sb-page-header mb-4">
      {breadcrumb && breadcrumb.length > 0 && (
        <nav className="sb-page-header__breadcrumb mb-2" aria-label="Breadcrumb">
          {breadcrumb.map((item, index) => (
            <span key={item.to}>
              {index > 0 && <span className="sb-page-header__breadcrumb-sep mx-1">›</span>}
              {index === breadcrumb.length - 1 ? (
                <span className="text-muted">{item.label}</span>
              ) : (
                <Link to={item.to} className="sb-page-header__breadcrumb-link">
                  {item.label}
                </Link>
              )}
            </span>
          ))}
        </nav>
      )}
      <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
        <div className="min-w-0">
          <h1 className="sb-page-header__title mb-1">{title}</h1>
          {subtitle && <p className="sb-page-header__subtitle mb-0">{subtitle}</p>}
        </div>
        <div className="d-flex flex-wrap align-items-center gap-2 ms-md-auto">
          {actions}
          {backTo && (
            <Link to={backTo.to} className="sb-page-header__back-link">
              <i className="fas fa-arrow-left me-1" aria-hidden />
              {backTo.label}
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
